import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "statement" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    current: 2,
    btnText: `确认，提交认证`,
    isDisabled: _ctx.isDisabled,
    prePathName: "pi-ar"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "客户声明", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("p", null, "客户谨此确认：", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateList, (item) => {
          return (_openBlock(), _createElementBlock("p", {
            key: item.name
          }, [
            _createTextVNode(_toDisplayString(item.name) + " ", 1),
            (item.value==='35')
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  _cache[2] || (_cache[2] = _createTextVNode(" 英文语言可查看原表链接:")),
                  _createElementVNode("span", {
                    style: {"text-decoration":"underline","color":"#ffb400"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPdf && _ctx.showPdf(...args)))
                  }, " 《专业投资者声明书（个人及法团)》")
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createVNode(_component_van_field, {
          name: "agree",
          rules: [{ required: true, message: '请您勾选协议' }]
        }, {
          input: _withCtx(() => [
            _createVNode(_component_van_checkbox, {
              modelValue: _ctx.form.customerChecked,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.customerChecked) = $event)),
              shape: "square"
            }, {
              icon: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(
                  `iconfont ${
                    _ctx.form.customerChecked ? 'icon-duoxuanxuanzhong' : 'icon-duoxuanweixuanzhong'
                  }`
                )
                }, null, 2)
              ]),
              default: _withCtx(() => [
                _cache[3] || (_cache[3] = _createTextVNode(" 本人已阅读并同意 "))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["onHandleNext", "isDisabled"]))
}